var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"common-button",class:{
    'just-icon': !_vm.element.propValue
  },attrs:{"type":_vm.statusConfig.type,"size":_vm.statusConfig.size,"plain":_vm.statusConfig.plain,"round":_vm.statusConfig.round,"circle":_vm.statusConfig.circle,"loading":_vm.statusConfig.loading,"disabled":_vm.statusConfig.disabled,"icon":_vm.statusConfig.icon,"autofocus":_vm.statusConfig.autofocus}},[_vm._v(_vm._s(_vm.element.propValue || ''))])
}
var staticRenderFns = []

export { render, staticRenderFns }